import { Outlet } from 'react-router-dom';
import { InvoiceMonthProvider } from './InvoiceMonth';

/**
 * Layout route for /invoices/*. Provides the shared month selection so it persists as the user
 * moves between Summary, Issued, and Received.
 */
export function InvoicesLayout() {
  return (
    <InvoiceMonthProvider>
      <Outlet />
    </InvoiceMonthProvider>
  );
}
